import { CustomSubconfigurationNavigationComponents } from "../CustomSubconfigurationNavigationComponents/CustomSubconfigurationNavigationComponents";

import type { JSX } from "react";

import {
  SubconfigurationNavigationContent,
  SubconfigurationNavigationControl,
  SubconfigurationNavigationOrientation,
  SubconfigurationNavigationProps,
  SubconfigurationNavigationSecondaryControl,
  useSubconfigurationNavigation,
  useSubconfigurationNavigationItems,
} from "@plansoft-configuration-renderer/components";
import { TextMode } from "@plansoft-configuration-renderer/framework";

/**
 * Tab control on configuration level
 * @category UI
 * @param props
 * @returns
 */
export function CustomSubConfigurationNavigation(
  props: SubconfigurationNavigationProps,
): JSX.Element {
  const {
    control = SubconfigurationNavigationControl.Stepper,
    orientation = SubconfigurationNavigationOrientation.Horizontal,
    secondaryControl = SubconfigurationNavigationSecondaryControl.Buttons,
    components = CustomSubconfigurationNavigationComponents,
    textMode = TextMode.PlainText,
  } = props;

  const items = useSubconfigurationNavigationItems({});

  const {
    activePath,
    setActivePath,
    resetActivePath,
    next,
    nextDisabled,
    previous,
    previousDisabled,
  } = useSubconfigurationNavigation(items);

  const {
    NavigationComponents,
    SecondaryNavigationComponents,
    AlignmentComponents,
    ContentComponents,
  } = components;

  const Navigation = NavigationComponents[control];
  const SecondaryNavigation = SecondaryNavigationComponents[secondaryControl];
  const AlignmentComponent = AlignmentComponents[orientation];

  const activeItem = items.find((item) => item.path === activePath);

  return (
    <AlignmentComponent
      navigation={
        <Navigation
          orientation={orientation}
          activePath={activePath}
          setActivePath={setActivePath}
          items={items}
          navigationStyle={props.navigationStyle}
          showCompletenessIndicator={props.showCompletenessIndicator}
          stepperProps={props.stepperProps}
          textMode={textMode}
        />
      }
      content={
        activeItem ? (
          <>
            <SubconfigurationNavigationContent
              key={activeItem.path} // key needs to be set to force re-render
              item={activeItem}
              components={ContentComponents}
            />

            <SecondaryNavigation
              onNextClicked={next}
              onPreviousClicked={previous}
              nextDisabled={nextDisabled}
              previousDisabled={previousDisabled}
              onResetClicked={resetActivePath}
              resetDisabled={false}
            />
          </>
        ) : null
      }
    />
  );
}
